export class PobierzDaneDoWyboruRaportuModel {
    idProjektu: string;
    idLokalizacji: string;
    idPomieszczenia: string;
}